import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { IPaginationPayload, IPaginationPayloadWithId } from '../../../../interfaces/shared/IPaginationPayload';
import { GuestsService } from './guestsApi';


const initialState: any = {
    guestIsLoading: false,
    guestReservationsLoading: false,
    guestsAreLoading: false,
    requestStatus: 'default',
    message: '',
};

export const tryToFetchGuestsByRoom = createAsyncThunk<any, IPaginationPayload>(
    'guests/tryToFetchGuestsByRoom',
    async ({ pageNumber, pageSize, data }) => {
        const result = await GuestsService.tryToFetchGuestsByRoom(pageNumber, pageSize, data);
        return result?.data;
    },
);

export const tryToFetchSingleGuest = createAsyncThunk<any, string>(
    'guests/tryToFetchSingleGuest',
    async (id: string) => {
        const result = await GuestsService.tryToFetchSingleGuest(id);
        return result?.data?.data;
    },
);

export const tryToFetchGuestAllReservations = createAsyncThunk<any, IPaginationPayloadWithId>(
    'guests/tryToFetchGuestAllReservations',
    async ({ id, pageNumber, pageSize, data }) => {
        const result = await GuestsService.tryToFetchGuestAllReservations(id, pageNumber, pageSize, data);
        return result?.data;
    },
);


export const tryToFetchGuestsSchedule = createAsyncThunk<any, IPaginationPayload>(
    'guests/tryToFetchGuestsSchedule',
    async ({ pageNumber, pageSize, data }) => {
        const result = await GuestsService.tryToFetchGuestsSchedule(pageNumber, pageSize, data);
        return result?.data;
    },
);

export const tryToFetchSingleGuest2 = createAsyncThunk<any, string>(
    'guests/tryToFetchSingleGuest',
    async (id: string) => {
        const result = await GuestsService.tryToFetchSingleGuest2(id);
		console.log({result})
        return result?.data;
    },
);

export const tryToFetchGuestAllBooking = createAsyncThunk<any, IPaginationPayloadWithId>(
    'guests/tryToFetchGuestAllReservations',
    async ({ id, pageNumber, pageSize, data }) => {
        const result = await GuestsService.tryToFetchGuestAllBooking(id, pageNumber, pageSize, data);
        return result?.data;
    },
);

export const guestsSlice = createSlice({
    name: 'guests',
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            // tryToFetchGuestsByRoom
            .addCase(tryToFetchGuestsByRoom.pending, (state) => {
                state.guestsAreLoading = true;
            })
            .addCase(tryToFetchGuestsByRoom.rejected, (state) => {
                state.guestsAreLoading = false;
            })
            .addCase(tryToFetchGuestsByRoom.fulfilled, (state, action) => {
                state.guestsAreLoading = false;
                state.guests = action.payload;
            })
			// tryToFetchGuestsSchedule
            .addCase(tryToFetchGuestsSchedule.pending, (state) => {
                state.guestsAreLoading = true;
            })
            .addCase(tryToFetchGuestsSchedule.rejected, (state) => {
                state.guestsAreLoading = false;
            })
            .addCase(tryToFetchGuestsSchedule.fulfilled, (state, action) => {
                state.guestsAreLoading = false;
                state.guests2 = action.payload;
            })

            // tryToFetchGuestAllReservations
            .addCase(tryToFetchGuestAllReservations.pending, (state) => {
                state.guestReservationsLoading = true;
            })
            .addCase(tryToFetchGuestAllReservations.rejected, (state) => {
                state.guestReservationsLoading = false;
            })
            .addCase(tryToFetchGuestAllReservations.fulfilled, (state, action) => {
                state.guestReservationsLoading = false;
                state.guestReservations = action.payload;
            })

            // tryToFetchSingleGuest
            .addCase(tryToFetchSingleGuest.pending, (state) => {
                state.guestIsLoading = true;
            })
            .addCase(tryToFetchSingleGuest.rejected, (state) => {
                state.guestIsLoading = false;
            })
            .addCase(tryToFetchSingleGuest.fulfilled, (state, action) => {
                state.guestIsLoading = false;
                state.guestDetails = action.payload;
            })
    },
});

export default guestsSlice.reducer;